export default {
    API: "https://api.humaads.live",
    WS: "wss://api.humaads.live"
}